import { LoaderFunction, MetaFunction } from "@remix-run/node";
import { t } from "i18next";
import { requireAdminRole, requireAuth } from "~/utils/auth.server";

export const meta: MetaFunction = () => {
  return [
    { title: t("navigation.privacyPolicy") },
    {
      name: "description",
      content: "Privacy Policy",
    },
  ];
};

export const loader: LoaderFunction = async ({ request }) => {
  try {
    return null;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export default function PrivacyPolicy() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-5xl my-12 mb-32 text-center tracking-wide">
        Datenschutzerklärung
      </h1>
      <div className="mb-10 flex flex-col gap-4 ">
        <h1 className="text-3xl font-normal">Einleitung</h1>
        <p className="text-sm font-light leading-7">
          Mit der folgenden Datenschutzerklärung möchten wir Sie darüber <br />
          aufklären, welche Arten Ihrer personenbezogenen Daten (nachfolgend{" "}
          <br />
          auch kurz als „Daten“ bezeichnet) wir zu welchen Zwecken und in <br />
          welchem Umfang verarbeiten. Die Datenschutzerklärung gilt für alle von{" "}
          <br />
          uns durchgeführten Verarbeitungen personenbezogener Daten, sowohl{" "}
          <br /> im Rahmen der Erbringung unserer Leistungen als auch
          insbesondere <br /> auf unseren Webseiten, in mobilen Applikationen
          sowie innerhalb <br /> externer Onlinepräsenzen, wie z.B. unserer
          Social-Media-Profile <br /> (nachfolgend zusammenfassend bezeichnet
          als „Onlineangebot“).
        </p>
        <p className="text-sm font-light">
          Die verwendeten Begriffe sind nicht geschlechtsspezifisch.
        </p>
        <p className="text-sm font-light">Stand: 01. Januar 2024</p>
        <p className="text-2xl font-normal mt-4">Verantwortlicher</p>
        <p className="text-sm font-light leading-7">
          SGB Energie GmbH <br />
          Industriestraße 29-31 <br />
          82194 Gröbenzell
        </p>
        <p className="text-sm font-light leading-7">
          Vertretungsberechtigte Personen: Ludwig Winges
        </p>
        <p className="text-sm font-light">
          E-Mail-Adresse: info@sgb-energie.de
        </p>
        <p className="text-2xl font-normal mt-4">
          Datenschutzbeauftragter gem. Art. 37 Abs. 7 DS-GVO
        </p>
        <p className="text-sm font-light leading-7">
          Herr <span className="font-bold">Homed Stingl</span> <br />
          E-Mail:{" "}
          <span className="text-green-600 font-bold">
            datenschutz@mtg-group.de
          </span>
        </p>
        <p className="text-2xl font-normal mt-4">
          Übersicht der Verarbeitungen
        </p>
        <p className="text-sm font-light leading-7">
          Die nachfolgende Übersicht fasst die Arten der verarbeiteten Daten{" "}
          <br /> und die Zwecke ihrer Verarbeitung zusammen und verweist auf die{" "}
          <br /> betroffenen Personen.
        </p>
        <p className="text-2xl font-normal mt-4">
          Arten der verarbeiteten Daten
        </p>
        <p className="text-sm font-light leading-7">
          Bestandsdaten (z.B. Namen, Adressen).
          <br />
          Inhaltsdaten (z.B. Eingaben in Onlineformularen).
          <br />
          Kontaktdaten (z.B. E-Mail, Telefonnummern).
          <br />
          Meta-/Kommunikationsdaten (z.B. Geräte-Informationen, IP-Adressen).
          <br />
          Nutzungsdaten (z.B. besuchte Webseiten, Interesse an Inhalten,
          Zugriffszeiten).
          <br />
          Kategorien betroffener Personen
          <br />
          Kommunikationspartner.
          <br />
          Nutzer (z.B. Webseitenbesucher, Nutzer von Onlinediensten).
          <br />
          Zwecke der Verarbeitung
          <br />
          Bereitstellung unseres Onlineangebotes und Nutzerfreundlichkeit.
          <br />
          Konversionsmessung (Messung der Effektivität von Marketingmaßnahmen).
          <br />
          Direktmarketing (z.B. per E-Mail oder postalisch).
          <br />
          Feedback (z.B. Sammeln von Feedback via Online-Formular).
          <br />
          Marketing.
          <br />
          Kontaktanfragen und Kommunikation.
          <br />
          Profile mit nutzerbezogenen Informationen (Erstellen von <br />
          Nutzerprofilen).
          <br />
          Remarketing.
          <br />
          Reichweitenmessung (z.B. Zugriffsstatistiken, Erkennung <br />
          wiederkehrender Besucher).
          <br />
          Erbringung vertraglicher Leistungen und Kundenservice.
          <br />
          Verwaltung und Beantwortung von Anfragen.
          <br />
          Zielgruppenbildung (Bestimmung von für Marketingzwecke <br />{" "}
          relevanten Zielgruppen oder sonstige Ausgabe von Inhalten).
          <br />
          Maßgebliche Rechtsgrundlagen
        </p>
        <p className="text-sm font-light leading-7">
          Im Folgenden erhalten Sie eine Übersicht der Rechtsgrundlagen der
          <br />
          DSGVO, auf deren Basis wir personenbezogene Daten verarbeiten.
          <br />
          Bitte nehmen Sie zur Kenntnis, dass neben den Regelungen der <br />
          DSGVO nationale Datenschutzvorgaben in Ihrem bzw. unserem <br /> Wohn-
          oder Sitzland gelten können. Sollten ferner im Einzelfall <br />{" "}
          speziellere Rechtsgrundlagen maßgeblich sein, teilen wir Ihnen diese{" "}
          <br /> in der Datenschutzerklärung mit.
        </p>
        <p className="text-sm font-light leading-7">
          Einwilligung (Art. 6 Abs. 1 S. 1 lit. a. DSGVO) – Die betroffene
          Person hat ihre Einwilligung in die Verarbeitung der sie betreffenden
          personenbezogenen Daten für einen spezifischen Zweck oder mehrere
          bestimmte Zwecke gegeben.
          <br />
          <br />
          Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1
          lit. b. DSGVO) – Die Verarbeitung ist für die Erfüllung eines
          Vertrags, dessen Vertragspartei die betroffene Person ist, oder zur
          Durchführung vorvertraglicher Maßnahmen erforderlich, die auf Anfrage
          der betroffenen Person erfolgen.
          <br />
          <br />
          Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f. DSGVO) – Die
          Verarbeitung ist zur Wahrung der berechtigten Interessen des
          Verantwortlichen oder eines Dritten erforderlich, sofern nicht die
          Interessen oder Grundrechte und Grundfreiheiten der betroffenen
          Person, die den Schutz personenbezogener Daten erfordern, überwiegen.
          <br />
          <br />
        </p>
        <p className="text-sm font-light leading-7">
          Nationale Datenschutzregelungen in Deutschland: Zusätzlich zu den
          Datenschutzregelungen der Datenschutz-Grundverordnung gelten nationale
          Regelungen zum Datenschutz in Deutschland.
          <br />
          Hierzu gehört insbesondere das Gesetz zum Schutz vor Missbrauch
          personenbezogener Daten bei der Datenverarbeitung
          (Bundesdatenschutzgesetz – BDSG).
          <br />
          Das BDSG enthält insbesondere Spezialregelungen zum Recht auf
          Auskunft, zum Recht auf Löschung, zum Widerspruchsrecht, zur
          Verarbeitung besonderer Kategorien personenbezogener Daten, zur
          Verarbeitung für andere Zwecke und zur Übermittlung sowie
          automatisierten Entscheidungsfindung im Einzelfall einschließlich
          Profiling.
          <br />
          Des Weiteren regelt es die Datenverarbeitung für Zwecke des
          Beschäftigungsverhältnisses (§ 26 BDSG), insbesondere im Hinblick auf
          die Begründung, Durchführung oder Beendigung von
          Beschäftigungsverhältnissen sowie die Einwilligung von Beschäftigten.
          <br />
          Ferner können Landesdatenschutzgesetze der einzelnen Bundesländer zur
          Anwendung gelangen.
          <br />
        </p>

        <h2 className="text-2xl font-normal mt-8">Sicherheitsmaßnahmen</h2>
        <p className="text-sm font-light leading-7">
          Wir treffen nach Maßgabe der gesetzlichen Vorgaben unter
          Berücksichtigung des Stands der Technik, der Implementierungskosten
          und der Art, des Umfangs, der Umstände und der Zwecke der Verarbeitung
          sowie der unterschiedlichen Eintrittswahrscheinlichkeiten und des
          Ausmaßes der Bedrohung der Rechte und Freiheiten natürlicher Personen
          geeignete technische und organisatorische Maßnahmen, um ein dem Risiko
          angemessenes Schutzniveau zu gewährleisten.
          <br />
          <br />
          Zu den Maßnahmen gehören insbesondere die Sicherung der
          Vertraulichkeit, Integrität und Verfügbarkeit von Daten durch
          Kontrolle des physischen und elektronischen Zugangs zu den Daten als
          auch des sie betreffenden Zugriffs, der Eingabe, der Weitergabe, der
          Sicherung der Verfügbarkeit und ihrer Trennung.
          <br />
          Des Weiteren haben wir Verfahren eingerichtet, die eine Wahrnehmung
          von Betroffenenrechten, die Löschung von Daten und Reaktionen auf die
          Gefährdung der Daten gewährleisten.
          <br />
          Ferner berücksichtigen wir den Schutz personenbezogener Daten bereits
          bei der Entwicklung bzw. Auswahl von Hardware, Software sowie
          Verfahren entsprechend dem Prinzip des Datenschutzes, durch
          Technikgestaltung und durch datenschutzfreundliche Voreinstellungen.
          <br />
        </p>
        <h2 className="text-2xl font-normal mt-8">Löschung von Daten</h2>
        <p className="text-sm font-light leading-7">
          Die von uns verarbeiteten Daten werden nach Maßgabe der gesetzlichen
          Vorgaben gelöscht, sobald deren zur Verarbeitung erlaubten
          Einwilligungen widerrufen werden oder sonstige Erlaubnisse entfallen
          (z.B. wenn der Zweck der Verarbeitung dieser Daten entfallen ist oder
          sie für den Zweck nicht erforderlich sind).
          <br />
          <br />
          Sofern die Daten nicht gelöscht werden, weil sie für andere und
          gesetzlich zulässige Zwecke erforderlich sind, wird deren Verarbeitung
          auf diese Zwecke beschränkt.
          <br />
          D.h., die Daten werden gesperrt und nicht für andere Zwecke
          verarbeitet.
          <br />
          Das gilt z.B. für Daten, die aus handels- oder steuerrechtlichen
          Gründen aufbewahrt werden müssen oder deren Speicherung zur
          Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder
          zum Schutz der Rechte einer anderen natürlichen oder juristischen
          Person erforderlich ist.
          <br />
          <br />
          Unsere Datenschutzhinweise können ferner weitere Angaben zu der
          Aufbewahrung und Löschung von Daten beinhalten, die für die jeweiligen
          Verarbeitungen vorrangig gelten.
          <br />
        </p>
        <h2 className="text-2xl font-normal mt-8">Einsatz von Cookies</h2>
        <p className="text-sm font-light leading-7">
          Cookies sind Textdateien, die Daten von besuchten Websites oder
          Domains enthalten und von einem Browser auf dem Computer des Benutzers
          gespeichert werden.
          <br />
          Ein Cookie dient in erster Linie dazu, die Informationen über einen
          Benutzer während oder nach seinem Besuch innerhalb eines
          Onlineangebotes zu speichern.
          <br />
          Zu den gespeicherten Angaben können z.B. die Spracheinstellungen auf
          einer Webseite, der Loginstatus, ein Warenkorb oder die Stelle, an der
          ein Video geschaut wurde, gehören.
          <br />
          Zu dem Begriff der Cookies zählen wir ferner andere Technologien, die
          die gleichen Funktionen wie Cookies erfüllen (z.B. wenn Angaben der
          Nutzer anhand pseudonymer Onlinekennzeichnungen gespeichert werden,
          auch als „Nutzer-IDs" bezeichnet)
          <br />
          <br />
          Die folgenden Cookie-Typen und Funktionen werden unterschieden:
          <br />
          <br />
          Temporäre Cookies (auch: Session- oder Sitzungs-Cookies):
          <br />
          Temporäre Cookies werden spätestens gelöscht, nachdem ein Nutzer ein
          Online-Angebot verlassen und seinen Browser geschlossen hat.
          <br />
          <br />
          Permanente Cookies:
          <br />
          Permanente Cookies bleiben auch nach dem Schließen des Browsers
          gespeichert.
          <br />
          So kann beispielsweise der Login-Status gespeichert oder bevorzugte
          Inhalte direkt angezeigt werden, wenn der Nutzer eine Website erneut
          besucht.
          <br />
          Ebenso können die Interessen von Nutzern, die zur Reichweitenmessung
          oder zu Marketingzwecken verwendet werden, in einem solchen Cookie
          gespeichert werden.
          <br />
        </p>
        <p className="text-sm font-light leading-7">
          First-Party-Cookies:
          <br />
          First-Party-Cookies werden von uns selbst gesetzt.
          <br />
          <br />
          Third-Party-Cookies (auch: Drittanbieter-Cookies):
          <br />
          Drittanbieter-Cookies werden hauptsächlich von Werbetreibenden (sog.
          Dritten) verwendet, um Benutzerinformationen zu verarbeiten.
          <br />
          <br />
          Notwendige (auch: essentielle oder unbedingt erforderliche) Cookies:
          <br />
          Cookies können zum einen für den Betrieb einer Webseite unbedingt
          erforderlich sein (z.B. um Logins oder andere Nutzereingaben zu
          speichern oder aus Gründen der Sicherheit).
          <br />
          <br />
          Statistik-, Marketing- und Personalisierungs-Cookies:
          <br />
          Ferner werden Cookies im Regelfall auch im Rahmen der
          Reichweitenmessung eingesetzt sowie dann, wenn die Interessen eines
          Nutzers oder sein Verhalten (z.B. Betrachten bestimmter Inhalte,
          Nutzen von Funktionen etc.) auf einzelnen Webseiten in einem
          Nutzerprofil gespeichert werden.
          <br />
          Solche Profile dienen dazu, den Nutzern z.B. Inhalte anzuzeigen, die
          ihren potentiellen Interessen entsprechen.
          <br />
          Dieses Verfahren wird auch als „Tracking", d.h., Nachverfolgung der
          potentiellen Interessen der Nutzer bezeichnet.
          <br />
          Soweit wir Cookies oder „Tracking"-Technologien einsetzen, informieren
          wir Sie gesondert in unserer Datenschutzerklärung oder im Rahmen der
          Einholung einer Einwilligung.
          <br />
        </p>
        <h3 className="text-xl font-normal mt-6">
          Hinweise zu Rechtsgrundlagen:
        </h3>
        <p className="text-sm font-light leading-7">
          Auf welcher Rechtsgrundlage wir Ihre personenbezogenen Daten mit Hilfe
          von Cookies verarbeiten, hängt davon ab, ob wir Sie um eine
          Einwilligung bitten.
          <br />
          Falls dies zutrifft und Sie in die Nutzung von Cookies einwilligen,
          ist die Rechtsgrundlage der Verarbeitung Ihrer Daten die erklärte
          Einwilligung.
          <br />
          Andernfalls werden die mithilfe von Cookies verarbeiteten Daten auf
          Grundlage unserer berechtigten Interessen (z.B. an einem
          betriebswirtschaftlichen Betrieb unseres Onlineangebotes und dessen
          Verbesserung) verarbeitet oder, wenn der Einsatz von Cookies
          erforderlich ist, um unsere vertraglichen Verpflichtungen zu erfüllen.
          <br />
          <br />
          Speicherdauer:
          <br />
          Sofern wir Ihnen keine expliziten Angaben zur Speicherdauer von
          permanenten Cookies mitteilen (z. B. im Rahmen eines sog.
          Cookie-Opt-Ins), gehen Sie bitte davon aus, dass die Speicherdauer bis
          zu zwei Jahre betragen kann.
          <br />
          <br />
          Allgemeine Hinweise zum Widerruf und Widerspruch (Opt-Out):
          <br />
          Abhängig davon, ob die Verarbeitung auf Grundlage einer Einwilligung
          oder gesetzlichen Erlaubnis erfolgt, haben Sie jederzeit die
          Möglichkeit, eine erteilte Einwilligung zu widerrufen oder der
          Verarbeitung Ihrer Daten durch Cookie-Technologien zu widersprechen
          (zusammenfassend als „Opt-Out" bezeichnet).
          <br />
          Sie können Ihren Widerspruch zunächst mittels der Einstellungen Ihres
          Browsers erklären, z.B., indem Sie die Nutzung von Cookies
          deaktivieren (wobei hierdurch auch die Funktionsfähigkeit unseres
          Onlineangebotes eingeschränkt werden kann).
          <br />
        </p>
        <h2 className="text-2xl font-normal mt-8">
          Verarbeitung von Cookie-Daten auf Grundlage einer Einwilligung
        </h2>
        <p className="text-sm font-light leading-7">
          Wir setzen ein Verfahren zum Cookie-Einwilligungs-Management ein, in
          dessen Rahmen die Einwilligungen der Nutzer in den Einsatz von
          Cookies, bzw. der im Rahmen des
          Cookie-Einwilligungs-Management-Verfahrens genannten Verarbeitungen
          und Anbieter eingeholt sowie von den Nutzern verwaltet und widerrufen
          werden können.
          <br />
          Hierbei wird die Einwilligungserklärung gespeichert, um deren Abfrage
          nicht erneut wiederholen zu müssen und die Einwilligung entsprechend
          der gesetzlichen Verpflichtung nachweisen zu können.
          <br />
          Die Speicherung kann serverseitig und/oder in einem Cookie
          (sogenanntes Opt-In-Cookie, bzw. mithilfe vergleichbarer Technologien)
          erfolgen, um die Einwilligung einem Nutzer, bzw. dessen Gerät zuordnen
          zu können.
          <br />
          Vorbehaltlich individueller Angaben zu den Anbietern von
          Cookie-Management-Diensten, gelten die folgenden Hinweise:
          <br />
          Die Dauer der Speicherung der Einwilligung kann bis zu zwei Jahren
          betragen.
          <br />
          Hierbei wird ein pseudonymer Nutzer-Identifikator gebildet und mit dem
          Zeitpunkt der Einwilligung, Angaben zur Reichweite der Einwilligung
          (z. B. welche Kategorien von Cookies und/oder Diensteanbieter) sowie
          dem Browser, System und verwendeten Endgerät gespeichert.
          <br />
        </p>
        <h2 className="text-2xl font-normal mt-8">
          Rechte der betroffenen Personen
        </h2>
        <p className="text-sm font-light leading-7">
          Ihnen stehen als Betroffene nach der DSGVO verschiedene Rechte zu, die
          sich insbesondere aus Art. 15 bis 21 DSGVO ergeben:
          <br />
          <br />
          Widerspruchsrecht: Sie haben das Recht, aus Gründen, die sich aus
          Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung
          der Sie betreffenden personenbezogenen Daten, die aufgrund von Art. 6
          Abs. 1 lit. e oder f DSGVO erfolgt, Widerspruch einzulegen; dies gilt
          auch für ein auf diese Bestimmungen gestütztes Profiling.
          <br />
          Werden die Sie betreffenden personenbezogenen Daten verarbeitet, um
          Direktwerbung zu betreiben, haben Sie das Recht, jederzeit Widerspruch
          gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten
          zum Zwecke derartiger Werbung einzulegen; dies gilt auch für das
          Profiling, soweit es mit solcher Direktwerbung in Verbindung steht.
          <br />
          <br />
          Widerrufsrecht bei Einwilligungen: Sie haben das Recht, erteilte
          Einwilligungen jederzeit zu widerrufen.
          <br />
          <br />
          Auskunftsrecht: Sie haben das Recht, eine Bestätigung darüber zu
          verlangen, ob betreffende Daten verarbeitet werden und auf Auskunft
          über diese Daten sowie auf weitere Informationen und Kopie der Daten
          entsprechend den gesetzlichen Vorgaben.
          <br />
          <br />
          Recht auf Berichtigung: Sie haben entsprechend den gesetzlichen
          Vorgaben das Recht, die Vervollständigung der Sie betreffenden Daten
          oder die Berichtigung der Sie betreffenden unrichtigen Daten zu
          verlangen.
          <br />
          <br />
          Recht auf Löschung und Einschränkung der Verarbeitung: Sie haben nach
          Maßgabe der gesetzlichen Vorgaben das Recht, zu verlangen, dass Sie
          betreffende Daten unverzüglich gelöscht werden, bzw. alternativ nach
          Maßgabe der gesetzlichen Vorgaben eine Einschränkung der Verarbeitung
          der Daten zu verlangen.
          <br />
          <br />
          Recht auf Datenübertragbarkeit: Sie haben das Recht, Sie betreffende
          Daten, die Sie uns bereitgestellt haben, nach Maßgabe der gesetzlichen
          Vorgaben in einem strukturierten, gängigen und maschinenlesbaren
          Format zu erhalten oder deren Übermittlung an einen anderen
          Verantwortlichen zu fordern.
          <br />
          <br />
          Beschwerde bei Aufsichtsbehörde: Sie haben unbeschadet eines
          anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs
          das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in
          dem Mitgliedstaat ihres gewöhnlichen Aufenthaltsorts, ihres
          Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes, wenn Sie der
          Ansicht sind, dass die Verarbeitung der Sie betreffenden
          personenbezogenen Daten gegen die Vorgaben der DSGVO verstößt.
          <br />
        </p>
        <h2 className="text-2xl font-normal mt-8">Begriffsdefinitionen</h2>
        <p className="text-sm font-light leading-7">
          In diesem Abschnitt erhalten Sie eine Übersicht über die in dieser
          Datenschutzerklärung verwendeten Begrifflichkeiten. Viele der Begriffe
          sind dem Gesetz entnommen und vor allem im Art. 4 DSGVO definiert. Die
          gesetzlichen Definitionen sind verbindlich. Die nachfolgenden
          Erläuterungen sollen dagegen vor allem dem Verständnis dienen. Die
          Begriffe sind alphabetisch sortiert.
          <br />
          <br />
          IP-Masking: Als „IP-Masking" wird eine Methode bezeichnet, bei der das
          letzte Oktett, d.h., die letzten beiden Zahlen einer IP-Adresse,
          gelöscht wird, damit die IP-Adresse nicht mehr der eindeutigen
          Identifizierung einer Person dienen kann. Daher ist das IP-Masking ein
          Mittel zur Pseudonymisierung von Verarbeitungsverfahren, insbesondere
          im Onlinemarketing
          <br />
          <br />
          Konversionsmessung: Die Konversionsmessung (auch als
          „Besuchsaktionsauswertung" bezeichnet) ist ein Verfahren, mit dem die
          Wirksamkeit von Marketingmaßnahmen festgestellt werden kann. Dazu wird
          im Regelfall ein Cookie auf den Geräten der Nutzer innerhalb der
          Webseiten, auf denen die Marketingmaßnahmen erfolgen, gespeichert und
          dann erneut auf der Zielwebseite abgerufen. Beispielsweise können wir
          so nachvollziehen, ob die von uns auf anderen Webseiten geschalteten
          Anzeigen erfolgreich waren.
          <br />
          <br />
          Personenbezogene Daten: „Personenbezogene Daten" sind alle
          Informationen, die sich auf eine identifizierte oder identifizierbare
          natürliche Person (im Folgenden „betroffene Person") beziehen; als
          identifizierbar wird eine natürliche Person angesehen, die direkt oder
          indirekt, insbesondere mittels Zuordnung zu einer Kennung wie einem
          Namen, zu einer Kennnummer, zu Standortdaten, zu einer Online-Kennung
          (z.B. Cookie) oder zu einem oder mehreren besonderen Merkmalen
          identifiziert werden kann, die Ausdruck der physischen,
          physiologischen, genetischen, psychischen, wirtschaftlichen,
          kulturellen oder sozialen Identität dieser natürlichen Person sind.
          <br />
          <br />
        </p>
        <p className="text-sm font-light leading-7">
          Profile mit nutzerbezogenen Informationen: Die Verarbeitung von
          „Profilen mit nutzerbezogenen Informationen", bzw. kurz „Profilen"
          umfasst jede Art der automatisierten Verarbeitung personenbezogener
          Daten, die darin besteht, dass diese personenbezogenen Daten verwendet
          werden, um bestimmte persönliche Aspekte, die sich auf eine natürliche
          Person beziehen zu analysieren, zu bewerten oder, um sie
          vorherzusagen.
          <br />
          <br />
          Reichweitenmessung: Die Reichweitenmessung (auch als Web Analytics
          bezeichnet) dient der Auswertung der Besucherströme eines
          Onlineangebotes und kann das Verhalten oder Interessen der Besucher an
          bestimmten Informationen, wie z.B. Inhalten von Webseiten, umfassen.
          <br />
          Mit Hilfe der Reichweitenanalyse können Webseiteninhaber z.B.
          erkennen, zu welcher Zeit Besucher ihre Webseite besuchen und für
          welche Inhalte sie sich interessieren.
          <br />
          Dadurch können sie z.B. die Inhalte der Webseite besser an die
          Bedürfnisse ihrer Besucher anpassen.
          <br />
          <br />
          Remarketing: Vom „Remarketing" bzw. „Retargeting" spricht man, wenn
          z.B. zu Werbezwecken vermerkt wird, für welche Produkte sich ein
          Nutzer auf einer Webseite interessiert hat, um den Nutzer auf anderen
          Webseiten an diese Produkte, z.B. in Werbeanzeigen, zu erinnern.
          <br />
          <br />
        </p>
        <p className="text-sm font-light leading-7">
          Verantwortlicher: Als „Verantwortlicher" wird die natürliche oder
          juristische Person, Behörde, Einrichtung oder andere Stelle, die
          allein oder gemeinsam mit anderen über die Zwecke und Mittel der
          Verarbeitung von personenbezogenen Daten entscheidet, bezeichnet.
          <br />
          <br />
          Verarbeitung: „Verarbeitung" ist jeder mit oder ohne Hilfe
          automatisierter Verfahren ausgeführte Vorgang oder jede solche
          Vorgangsreihe im Zusammenhang mit personenbezogenen Daten. Der Begriff
          reicht weit und umfasst praktisch jeden Umgang mit Daten, sei es das
          Erheben, das Auswerten, das Speichern, das Übermitteln oder das
          Löschen.
          <br />
          <br />
          Zielgruppenbildung: Von Zielgruppenbildung (bzw. „Custom Audiences")
          spricht man, wenn Zielgruppen für Werbezwecke, z.B. Einblendung von
          Werbeanzeigen, bestimmt werden.
          <br />
          So kann z.B. anhand des Interesses eines Nutzers an bestimmten
          Produkten oder Themen im Internet geschlussfolgert werden, dass dieser
          Nutzer sich für Werbeanzeigen für ähnliche Produkte oder den
          Onlineshop, in dem er die Produkte betrachtet hat, interessiert.
          <br />
          Von „Lookalike Audiences" (bzw. ähnlichen Zielgruppen) spricht man
          wiederum, wenn die als geeignet eingeschätzten Inhalte Nutzern
          angezeigt werden, deren Profile bzw. Interessen mutmaßlich den
          Nutzern, zu denen die Profile gebildet wurden, entsprechen.
          <br />
          Zu Zwecken der Bildung von Custom Audiences und Lookalike Audiences
          werden im Regelfall Cookies und Web-Beacons eingesetzt.
          <br />
        </p>

        <p className="text-sm font-light leading-7 mt-8">
          Diese Website ist durch reCAPTCHA geschützt und es gelten die{" "}
          <span className="text-green-600 italic">
            Datenschutzbestimmungen{" "}
          </span>
           und  <span className="text-green-600 italic">
            Nutzungsbedingungen 
          </span> von Google.
          <br />
        </p>
      </div>
    </div>
  );
}
